// extracted by mini-css-extract-plugin
export var grid = "PageProducerList-module--grid--ERVZb";